<ng-container *ngIf="!isDeliveryConfirmation">
  <div *ngIf="deliveryCurrent" class="basket-confirm">

    <app-delivery-list
      [deliveryCurrent]="deliveryCurrent"
      [deliveryList]="deliveryList"
      [wars]="wars"
      (deliveryChange)="switchesDeliveryType($event)"
    />

    <div class="del-type">
      <div class="del-type-comment"
           [innerHTML]="deliveryCurrent.comment"
      ></div>

      <div class="del-type-np-city">
        <div class="del-type-np-city-text">
          <label>Місто</label>
          <small>(Пропишіть і виберіть зі списку)</small>
        </div>
        <div class="del-type-np-city-input">
          <input
            #scrollInputRef
            type='text'
            placeholder='Пропишіть місто і виберіть зі списку'
            autocomplete='off'
            [class.border-wrong]="wrongDeliveryNPCity"
            [(ngModel)]="lastAddress.city"
            (input)="inputNpCity()"
          >
          <div *ngIf="npCitySearchResults" class="np-city-search-results">
            <div (click)="npSetCity(address)" *ngFor="let address of npCitySearchResults">
              {{ address.description }}
            </div>
          </div>
          <span class="status-error" *ngIf="wrongDeliveryNPCity">Введіть назву міста (мінімально 3 символи) і виберіть його зі списку</span>
        </div>
      </div>

      <div class="del-type-np-delivery-type">
        <div class="flex-container">
          <label [class.active]="addressedDeliveryType"
                 (click)="setNpDeliveryTypeBranch()"
          >
            У відділення
          </label>
          <span class="address-desktop">Адресна доставка</span>
          <span class="address-mobile">Адресна</span>
          <label [class.active]="!addressedDeliveryType"
                 (click)="setNpDeliveryTypeAddress()"
                 *ngIf="addressedDelivery"
          >
          </label>
        </div>
      </div>

      <div *ngIf="!addressedDeliveryType" class="del-type-np-delivery-address">
        <div class='del-type-np-delivery-address-street'>
          <label>Вулиця</label>
          <div>
            <input
              type='text'
              placeholder='Вулиця'
              [class.border-wrong]="wrongDeliveryAddressStreet"
              [(ngModel)]="lastAddress.np_addr_street"
              (input)="inputDeliveryAddressStreet()"
            >
            <button type="button" *ngIf="lastAddress.np_addr_street !== '' && lastAddress.np_addr_street !== null" class="cross-clears" (click)="crossClearAddressStreet()"></button>
            <span class="status-error" *ngIf="wrongDeliveryAddressStreet">Введіть назву вулиці</span>
          </div>
        </div>
        <div class='del-type-np-delivery-address-house'>
          <label>Будинок №</label>
          <div>
            <input
              type='text'
              placeholder='Будинок №'
              [class.border-wrong]="wrongDeliveryAddressHouse"
              [(ngModel)]="lastAddress.np_addr_house"
              (input)="inputDeliveryAddressHouse()"
            >
            <button type="button" *ngIf="lastAddress.np_addr_house !== '' && lastAddress.np_addr_house !== null" class="cross-clears" (click)="crossClearAddressHouse()"></button>
            <span class="status-error" *ngIf="wrongDeliveryAddressHouse">Введіть номер будинку</span>
          </div>
        </div>
        <div class='del-type-np-delivery-address-flat'>
          <label>Квартира №</label>
          <div>
            <input
              type='text'
              placeholder='Квартира №'
              [(ngModel)]="lastAddress.np_addr_flat"
            >
            <button type="button" *ngIf="lastAddress.np_addr_flat !== '' && lastAddress.np_addr_flat !== null" class="cross-clears" (click)="crossClearAddressFlat()"></button>
            <span class="status-hint">Для приватного будинку залиште порожнім</span>
          </div>
        </div>
      </div>

      <div class="del-type-np-delivery-wars" *ngIf="addressedDeliveryType">
        <label>Номер відділення</label>
        <div>
          <ng-select #scrollInputRef
                     [class.border-wrong]="wrongDeliveryDepartmentNumber || wrongDeliveryDepartmentWeight"
                     [(ngModel)]="deliveryDepartmentNumber"
                     (change)="deliveryDepartmentNumberChange()"
          >
            <ng-option [value]="-1">Вкажіть номер відділення</ng-option>
            <ng-container *ngFor="let war of npPostsResults">
              <ng-option
                [value]="war.number">
                №{{ war.number }} - {{ war.description }}
              </ng-option>
            </ng-container>
          </ng-select>
          <div class="error-messages">
            <span class="status-error" *ngIf="wrongDeliveryDepartmentNumber">Вкажіть номер відділення</span>
            <span class="status-error" *ngIf="wrongDeliveryDepartmentWeight">{{ errorMessageDeliveryDepartmentWeight }}</span>
            <span class="status-delivery" *ngIf="warehousesWeightHint">{{ warehousesWeightHint }}</span>
          </div>
        </div>
      </div>

      <span class="message-otgrujaem" *ngIf="showMessageOtgrujaem">Включено відвантаження без оплати</span>

      <!-- Відправник - сам клієнт-дропшипер (картка #866): ТТН оформлюємо від його імені в нашому кабінеті НП.
           Галочка є лише при прив'язаному в адмінці відправнику і без накладеного платежу. -->
      <div *ngIf="npSenderAvailable" class="info-position-np">
        <i class="fa fa-info-circle" (click)="npSenderUserInfoMessage()">
          <div class="bulb-info-message" [class.show-tooltip]="npSenderUserInfoMessageShow">
            <div class="bulbarrow"></div>
            <p class="appears-tooltip">
              Накладну Нової Пошти оформимо від вашого імені ({{ user.np_sender.name }}),
              доставку оплачуєте за своїм договором з Новою Поштою.
              Зніміть позначку - відправимо від імені компанії.
            </p>
          </div>
        </i>
        <div class="reserve-activation-title">
          Відправник — я
        </div>
        <div class="checkbox-reserve">
          <label
            [class.active]="npSenderUser"
            (click)="toggleNpSenderUser()">
          </label>
        </div>
      </div>

      <div *ngIf="!user.only_prepayment && (!activeOrganization || activeOrganization.type === 'fiz')" class="del-type-np-payment">
        <label>Спосіб оплати</label>
        <div>
          <select
            #scrollInputRef
            [class.border-wrong]="wrongNpDeliveryPayment"
            [(ngModel)]="npDeliveryPayment"
            (change)="setNpDeliveryPayment()">
            <option value="-1">Виберіть спосіб оплати замолення</option>
            <option value="0">Передоплата</option>
            <option value="1">Накладений платіж</option>
          </select>
          <span class="status-error" *ngIf="wrongNpDeliveryPayment">Виберіть спосіб оплати замолення</span>
          <span class="status-error" *ngIf="npDeliveryPayment == 1 && user.nalojka_markup > 0">
            За оформлення замовлення накладеним платежем
              <br>
              стягується додаткова оплата за його опрацювання
              <br>
              у розмірі {{user.nalojka_markup}} %
            </span>
        </div>
      </div>

      <div class="payment-activation-text">
        <div *ngIf="user.only_prepayment && (!activeOrganization || activeOrganization.type === 'fiz')" class="del-type-np-only-prepayment">
          Для активації «накладений платіж» будь ласка зверніться до адміністратора сайту.
        </div>
      </div>

      <div *ngIf="(npDeliveryPayment == 0 || user.only_prepayment) && !beznal && liters < user.np_big_delivery_liters && !npSenderUserActive"
           class="del-type-np-pay-type">
        <div class="select-flex-container">
          <div>
            <select [class.select-position-style]="!wrongNpDeliveryDiscount"
                    [class.border-wrong]="wrongNpDeliveryDiscount"
                    [(ngModel)]="npDeliveryDiscount"
                    (change)="setNpDeliveryDiscount()">
              <option value="-1">Виберіть спосіб оплати доставки</option>
              <option *ngIf="user.np_shipping_on_who != 1" value="1">Знижка на доставку</option>
              <option *ngIf="user.np_shipping_on_who != 2" value="0">Без знижки на доставку</option>
            </select>
            <span *ngIf="wrongNpDeliveryDiscount" class="status status-error">Виберіть спосіб оплати доставки</span>
          </div>
          <div>
            <i class="fa fa-info-circle mobile" (click)="infoPaymentModal()"></i>
          </div>
        </div>
        <i class="fa fa-info-circle desktop" (click)="infoPaymentModal()"></i>
      </div>

      <div class="payment-activation-text">
        <div *ngIf="user.np_shipping_on_who == 1 && !npSenderUserActive" class="del-type-np-shipping-who">
          <span>Для активації «знижки на доставку»  будь ласка зверніться до адміністратора сайту.</span>
        </div>
      </div>

      <div *ngIf="showDeclaredPrice && npDeliveryPayment == 0 && (!activeOrganization || activeOrganization.type === 'fiz')" class="del-type-np-declared-price">
        <label>Оціночна вартість замовлення</label>
        <div>
          <input
            type="number"
            [class.border-wrong]="wrongEstimateOfTheCostOfTheOrder"
            [(ngModel)]="declaredPrice"
            (input)="inputEstimateOfTheCostOfTheOrder()"
          >
          <button type="button" *ngIf="declaredPrice !== '' && declaredPrice !== null" class="cross-clears" (click)="crossClearPrice()"></button>
          <span class="status status-error"
                *ngIf="wrongEstimateOfTheCostOfTheOrder">Введіть вартість замовлення</span>
        </div>
      </div>

      <div class="del-type-np-nalojka-sum" *ngIf="showSumAfterPay">
        <label>Сума післяплати</label>
        <div>
          <input
            type="number"
            [class.border-wrong]="wrongSumAfterPay"
            [(ngModel)]="sumAfterPay"
            (input)="inputSumAfterPay()"
          >
          <span class="status-error"
                *ngIf="wrongSumAfterPay">Суму не меньше оціночної вартості замовлення ({{ summaUah }})</span>
        </div>
      </div>

      <div *ngIf="!user.only_prepayment && npDeliveryPayment == 1" class="del-type-np-compensation">
        <small class="alert">Компенсація післяплати </small>
        <b class="alert">{{ compensation }} UAH</b>
      </div>

      <div
        *ngIf="deliveryCurrent.working_details.will_be_transfer"
        class="del-type-date-limited"
      >
        <div>
          Дати відправлення обмежені в зв'язку
          з переміщенням з іншого складу
        </div>
      </div>

      <div class="del-type-date" *ngIf="deliveryCurrent.allow_delivery_dates">
        <label>
          Дата відправлення
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliveryDates"
            [(ngModel)]="deliveryDate"
            (change)="onUserChangeDeliveryDate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryDates">Вкажіть дату відправлення</span>
        </div>
      </div>

      <div class="del-type-date" *ngIf="separateOrders && deliveryCurrent?.delivery_dates_zak?.length">
        <label>
          Дата відправки переміщення з іншого складу
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliverySeparate"
            [(ngModel)]="deliverySeparate"
            (change)="changingValueDeliverySeparate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates_zak" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status-error" *ngIf="wrongDeliverySeparate">Вкажіть дату відправлення</span>
        </div>
      </div>

      <div *ngIf="deliveryHoursList.length" class="del-type-date">
        <label>
          Час відправки
        </label>
        <div>
          <select [class.border-wrong]="wrongDeliveryHours"
                  [(ngModel)]="deliveryHours"
                  (change)="changingValueDeliveryHours()">
            <option value="-1">
              Виберіть час відправки
            </option>
            <option *ngFor="let hour of deliveryHoursList" [value]="hour">
              {{ hour }}:00
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryHours">Виберіть час відправки</span>
        </div>
      </div>

      <!-- Скільки місць займе замовлення і скільки приблизно коштуватиме доставка (картка #218).
           Стоїть перед позначкою XXL-упаковки: клієнт бачить кількість місць і вже тоді вирішує,
           чи пакувати компактно. Якщо позначку увімкнено, кількість місць визначає склад -
           блок ховається сам. -->
      <app-delivery-estimate
        [deliveryId]="delivery"
        [cityRef]="lastAddress.novaposhta_city_id"
        [addressed]="!addressedDeliveryType"
        [shippingOnWho]="estimateShippingOnWho"
        [compactPack]="npCompactPack"
        [compactPackHint]="delivery === 3"
      />

      <div *ngIf="delivery === 3" class="info-position-np">
        <i class="fa fa-info-circle" (click)="npCompactPackInfoMessage()">
          <div class="bulb-info-message" [class.show-tooltip]="npCompactPackInfoMessageShow">
            <div class="bulbarrow"></div>
            <p class="appears-tooltip">
              Кілька місць обʼєднуються в один ящик до 30кг вартістю  55 грн.
              Так заощаджуєте на відправленні до 100 грн на одне місце.
            </p>
          </div>
        </i>
        <div class="reserve-activation-title">
          Запакувати максимально компактно
        </div>
        <div class="checkbox-reserve">
          <label
            [class.active]="npCompactPack"
            (click)="toggleNpCompactPack()">
          </label>
        </div>
      </div>

      <div *ngIf="!user.allow_reserve_order" class="activation-text">
        <p>Для активації «резерв» будь ласка <br> зверніться до адміністратора сайту.</p>
      </div>

      <div *ngIf="!user.np_allow_beznal" class="activation-text">
        <p>Для активації «Безготівкова оплата доставки» <br> будь ласка зверніться до адміністратора сайту.</p>
      </div>

      <div *ngIf="user.allow_reserve_order" class="info-position-np">
        <i class="fa fa-info-circle" (click)="reserveInfoMessage()">
          <div class="bulb-info-message" [class.show-tooltip]="reserveInfoMessageShow">
            <div class="bulbarrow"></div>
            <p *ngIf="reserveTimeOk" class="appears-tooltip">
              Ви можете поставити замовлення у резерв до 16:30, щоб відтермінувати відправку
            </p>
            <p *ngIf="!reserveTimeOk" class="appears-tooltip">
              Замовлення можна резервувати до 16:30 поточного дня
            </p>
          </div>
        </i>
        <div class="reserve-activation-title">
          Резерв
        </div>
        <div class="checkbox-reserve">
          <label *ngIf="reserveTimeOk"
                 [class.active]="reserve"
                 (click)="npGoodsReserve()">
          </label>
        </div>
      </div>

      <ng-container *ngIf="user.np_allow_beznal">
        <div class="del-type-np-delivery-beznal">
          <label [class.active]="beznal" (click)="npDeliveryBeznal()">
            Безготівкова оплата доставки
          </label>
        </div>
        <div *ngIf="beznal" class="del-type-np-beznal">
          <div class="discount-beznal">
            <div class="discount-text">Знижка на доставку недоступна для безготівкової оплати</div>
          </div>
          <div class='del-type-np-beznal-edrpou'>
            <label>ЕДРПОУ/РНОКПП</label>
            <div>
              <input
                #scrollInputRef
                type='text'
                inputmode='numeric'
                placeholder='ЕДРПОУ/РНОКПП'
                [class.border-wrong]="wrongLastAddressEdrpou"
                [(ngModel)]="lastAddress.edrpou"
                (input)="inputLastAddressEdrpou()"
              >
              <button type="button" *ngIf="lastAddress.edrpou !== '' && lastAddress.edrpou !== null" class="cross-clears" (click)="crossClearAddressEdrpou()"></button>
              <span class="status-error" *ngIf="wrongLastAddressEdrpou">Заповніть реквизити</span>
            </div>
          </div>
          <div class='del-type-np-beznal-name-company'>
            <label>Назва компанії</label>
            <div>
              <input
                #scrollInputRef
                type='text'
                placeholder='Назва компанії'
                [class.border-wrong]="wrongLastAddressOrganization"
                [(ngModel)]="lastAddress.organization"
                (input)="inputLastAddressOrganization()"
              >
              <button type="button" *ngIf="lastAddress.organization !== '' && lastAddress.organization !== null" class="cross-clears" (click)="crossClearAddressOrganization()"></button>
              <span class="status-error" *ngIf="wrongLastAddressOrganization">Напишіть назву компанії</span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="del-type-np-info-recipient-head">
        <h3>Інформація одержувача</h3>
      </div>
      <div class="del-type-np-info-recipient-lastname">
        <label>Прізвище</label>
        <div>
          <input
            type="text"
            name="last_name"
            placeholder="Прізвище одержувача"
            [class.border-wrong]="wrongLastName"
            [(ngModel)]="lastName"
            (input)="inputLastName()"
          >
          <button type="button" *ngIf="lastName !== ''" class="cross-clears" (click)="crossClearLastName()"></button>
          <span class="status" [class.status-error]="wrongLastName">{{ errorMessageLastName }}</span>
        </div>
      </div>
      <div class="del-type-np-info-recipient-firstname">
        <label>Ім'я</label>
        <div>
          <input
            type="text"
            name="name"
            placeholder="Ім'я одержувача"
            [class.border-wrong]="wrongName"
            [(ngModel)]="name"
            (input)="inputName()"
          >
          <button type="button" *ngIf="name !== ''" class="cross-clears" (click)="crossClearName()"></button>
          <span class="status" [class.status-error]="wrongName">{{ errorMessageName }}</span>
        </div>
      </div>
      <div class="del-type-np-info-recipient-middle-name">
        <label>По батькові</label>
        <div>
          <input
            type="text"
            name="second_name"
            placeholder="По батькові одержувача"
            [class.border-wrong]="wrongMiddleName"
            [(ngModel)]="middleName"
            (input)="inputMiddleName()"
          >
          <button type="button" *ngIf="middleName !== ''" class="cross-clears" (click)="crossClearMiddleName()"></button>
          <span class="status" [class.status-error]="wrongMiddleName">{{ errorMessageMiddleName }}</span>
        </div>
      </div>
      <div class="del-type-np-info-recipient-phone">
        <label>Телефон</label>
        <div>
          <input
            type="text"
            #phoneRef
            appPhoneMask
            [class.border-wrong]="wrongLastAddressPhone"
            [(ngModel)]="lastAddress.phone"
            (input)="inputLastAddressPhone()"
          >
          <button type="button" *ngIf="lastAddress.phone !== '' && !wrongLastAddressPhone" class="cross-clears" (click)="crossClearPhone()"></button>
          <span class="status-error" *ngIf="wrongLastAddressPhone">Введіть номер телефону</span>
        </div>
      </div>

      <div class="del-type-user-comment">
        <label>Коментар до замовлення</label>
        <div>
          <textarea [(ngModel)]="deliveryComment"></textarea>
        </div>
      </div>

      <div class="del-type-send">
        <a routerLink="/basket">Редагувати замовлення</a>
        <small style="color:red;font-size:10px; display: block">
          Важливо! Строк зберігання посилок у відділенні перевізника - 5 днів!<br>
          Автоповернення посилок по закінченню цього строку.<br>
          Забирайте посилки вчасно!
        </small>
        <div class="del-type-send-button">
          <app-order-in-progress-message [show]="showOrderInProgressMessage"/>
          <button class="button" [disabled]="isSendingPayment" (click)="sendPayment()">Відправити</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-modal-nalojka-info (nalojkaNotAgree)="nalojkaNotAgree()" (nalojkaNotShow)="nalojkaNotShow()"/>

<app-modal-np-discount-info
  [npShippingMarkupPercentage]="user && user.np_shipping_markup_percentage"
  (discountAgree)="deliveryDiscountAgree()"
  (discountNotAgree)="deliveryDiscountNotAgree()"
  (discountNotShow)="deliveryDiscountNotShow()"
/>

<app-modal-info-payment/>

<app-modal-cash-on-delivery-info
  (cashOnDeliveryInfoNotAgree)="cashOnDeliveryInfoNotAgree()"
  (cashOnDeliveryInfoAgree)="cashOnDeliveryInfoAgree()"
  (cashOnDeliveryInfoNotShowMore)="cashOnDeliveryInfoNotShowMore()"
/>

<app-modal-np-compact-pack-info
  [npCompactPackBoxPrice]="user && user.np_compact_pack_box_price"
  (compactPackAgree)="npCompactPackAgree()"
  (compactPackNotAgree)="npCompactPackNotAgree()"
/>

<app-message-delivery-np-confirm [sumAfterPay]="sumAfterPay"/>

